/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventDetail model module.
 * @module model/EventDetail
 * @version 1.0
 */
class EventDetail {
    /**
     * Constructs a new <code>EventDetail</code>.
     * @alias module:model/EventDetail
     */
    constructor() { 
        
        EventDetail.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventDetail</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventDetail} obj Optional instance to populate.
     * @return {module:model/EventDetail} The populated <code>EventDetail</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventDetail();

            if (data.hasOwnProperty('uuid')) {
                obj['uuid'] = ApiClient.convertToType(data['uuid'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('preview')) {
                obj['preview'] = ApiClient.convertToType(data['preview'], 'String');
            }
            if (data.hasOwnProperty('reminder')) {
                obj['reminder'] = ApiClient.convertToType(data['reminder'], 'Number');
            }
            if (data.hasOwnProperty('start_at')) {
                obj['start_at'] = ApiClient.convertToType(data['start_at'], 'String');
            }
            if (data.hasOwnProperty('remind_window')) {
                obj['remind_window'] = ApiClient.convertToType(data['remind_window'], 'String');
            }
            if (data.hasOwnProperty('is_running')) {
                obj['is_running'] = ApiClient.convertToType(data['is_running'], 'Number');
            }
            if (data.hasOwnProperty('is_past')) {
                obj['is_past'] = ApiClient.convertToType(data['is_past'], 'Number');
            }
            if (data.hasOwnProperty('details')) {
                obj['details'] = ApiClient.convertToType(data['details'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Uuid of the event
 * @member {String} uuid
 */
EventDetail.prototype['uuid'] = undefined;

/**
 * Name of the event
 * @member {String} name
 */
EventDetail.prototype['name'] = undefined;

/**
 * Preview of the event
 * @member {String} preview
 */
EventDetail.prototype['preview'] = undefined;

/**
 * time seted to remind
 * @member {Number} reminder
 */
EventDetail.prototype['reminder'] = undefined;

/**
 * start time of the event
 * @member {String} start_at
 */
EventDetail.prototype['start_at'] = undefined;

/**
 * time
 * @member {String} remind_window
 */
EventDetail.prototype['remind_window'] = undefined;

/**
 * live
 * @member {Number} is_running
 */
EventDetail.prototype['is_running'] = undefined;

/**
 * past
 * @member {Number} is_past
 */
EventDetail.prototype['is_past'] = undefined;

/**
 * details of the event
 * @member {String} details
 */
EventDetail.prototype['details'] = undefined;






export default EventDetail;

